<template>
  <div class="content">
    <validation-observer ref="observer">
      <h2 class="page-title">新規作成</h2>

      <div class="section-wrapper">
        <section class="order-syaryo bg-gray p-1 p-md-2">
          <table class="table">
            <tr>
              <th>会社名</th>
              <td>
                {{ account.SOFU_SAKI_MEI }}
              </td>
            </tr>
            <tr>
              <th>
                お名前
                <span class="must">必須</span>
              </th>
              <td>
                <div class="row ml-2">
                  <label class="mt-sm-2">姓</label>
                  <div class="col-md-4">
                    <validation-provider
                      name="TANTO_MEI_SEI"
                      v-slot="{ errors }"
                      rules="required|max:30|zenkaku|char"
                    >
                      <b-form-input
                        v-model="account.TANTO_MEI_SEI"
                        ref="TANTO_MEI_SEI"
                        maxlength="30"
                        :state="errors.length ? false : null"
                        placeholder="山田"
                        trim
                        @blur="
                          account.TANTO_MEI_SEI = replaceChar(
                            account.TANTO_MEI_SEI
                          )
                        "
                      />
                      <b-form-invalid-feedback>
                        <span class="border-red">{{ errors[0] }}</span>
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </div>
                  <label class="mt-2 ml-sm-4 mr-2">名</label>
                  <div class="col-md-4">
                    <validation-provider
                      name="TANTO_MEI"
                      v-slot="{ errors }"
                      rules="max:30|zenkaku|char"
                    >
                      <b-form-input
                        v-model="account.TANTO_MEI"
                        ref="TANTO_MEI"
                        maxlength="30"
                        :state="errors.length ? false : null"
                        placeholder="太郎"
                        trim
                        @blur="
                          account.TANTO_MEI = replaceChar(account.TANTO_MEI)
                        "
                      />
                      <b-form-invalid-feedback>
                        <span class="border-red">{{ errors[0] }}</span>
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <th>
                メールアドレス
                <span class="must">必須</span>
              </th>
              <td>
                <validation-provider
                  name="MAIL_ADDR"
                  v-slot="{ errors }"
                  rules="required|max:50|email"
                >
                  <b-form-input
                    v-model="account.MAIL_ADDR"
                    ref="MAIL_ADDR"
                    class="col-md-8"
                    maxlength="50"
                    :state="errors.length ? false : null"
                    placeholder="tanaka@mail.co.jp"
                    trim
                  />
                  <b-form-invalid-feedback>
                    <span class="border-red">{{ errors[0] }}</span>
                  </b-form-invalid-feedback>
                </validation-provider>
              </td>
            </tr>
          </table>
        </section>
      </div>

      <div class="text-center mr-3 mr-md-0">
        <md-button
          type="button"
          class="btn-lg btn-secondary base-btn col-md-3 col-lg-2"
          :to="{ name: 'SettingIndex' }"
        >
          もどる
        </md-button>
        <br v-if="isMobile" />
        <md-button
          type="button"
          class="btn-lg btn-success base-btn col-md-3 col-lg-2 md-raised"
          @click="saveAccount"
        >
          登録
        </md-button>
        <md-dialog-alert
          class="new"
          :md-fullscreen="false"
          @md-opened="scroll('locked')"
          @md-closed="scroll('clear')"
          :md-active.sync="isSaved"
          md-content="<strong>登録が完了しました。</strong>"
        />
      </div>
    </validation-observer>
  </div>
</template>

<script>
import Mixin from '../mixin/Mixin'
import Store from '@/store/index.js'

export default {
  name: 'AccountCreate',
  components: {},
  mixins: [Mixin],
  data: () => ({
    account: {
      JYUCYU_SHIKI_CD: '',
      SOFU_SAKI_MEI: '',
      TANTO_MEI_SEI: '',
      TANTO_MEI: '',
      MAIL_ADDR: '',
      ROLE: 'members',
    },
    isSaved: false,

    /** オブザーバー */
    observer: null,
  }),

  methods: {
    /**
     * アカウント登録
     */
    async saveAccount() {
      const valid = await this.observer.validate()
      if (!valid) return this._alert('入力項目にエラーがあります。')

      this.spinerOn()
      return this.$store
        .dispatch('account/setAccount', this.account)
        .then((res) => {
          this.scroll('clear')
          this.isSaved = true
          // データ初期化
          this.observer.reset()
          this.account.TANTO_MEI_SEI = ''
          this.account.TANTO_MEI = ''
          this.account.MAIL_ADDR = ''
          this.spinerOff()
        })
        .catch((err) => {
          this.spinerOff()
          throw new Error(err.message)
        })
    },
  },

  mounted() {
    this.observer = this.$refs.observer
  },

  created() {
    const user = Store.state.user.data
    this.account.JYUCYU_SHIKI_CD = user.JYUCYU_SHIKI_CD
    this.account.SOFU_SAKI_MEI = user.hum_torihiki.SOFU_SAKI_MEI
  },
}
</script>

<style lang="sass" scoped>
@import '../../assets/css/logico2'
table
  margin: 0
  th
    background: $baseBlueColor
    color: #fff
    width: 32%
    padding: 1.5%
  td
    width: 68%
    background: #fff
</style>



// WEBPACK FOOTER //
// src/components/setting/Create.vue